import { AccordionFolderContentSubitem } from 'twyne-new.ui'

import useTemplateData from '@/modules/cms/views/post/components/builder/hooks/useTheme/useTemplateData'

import EditingTitle from "./EditingTitle"
import TemplateActions from './TemplateActions'

export default function Template({ data, onSelect, isActive, onRemove }) {
  const { name, isEditing, isNew } = useTemplateData(data)

  return <AccordionFolderContentSubitem
    title={<EditingTitle value={name} isEditing={isEditing} isNew={isNew} />}
    onClick={() => onSelect(data)}
    active={isActive(data.name)}
    actions={<TemplateActions setIsEditing={isEditing.setValue} onRemove={onRemove} />}
  />
}
